import {Entidade} from "./Entidade";
import {BannerTipo} from "./BannerTipo";
import Restaurante from "./Restaurante";
import {PagamentoStatus} from "./PagamentoStatus";
import {TipoPagamento} from "./TipoPagamento";

export default class Banner extends Entidade {

    restaurante?: Restaurante;
    tipo?: BannerTipo = BannerTipo.EXTERNO;
    formaPagamento?: TipoPagamento = TipoPagamento.NENHUM;
    tituloFraseExterno?: string;
    fraseExterno?: string;
    dataInicial?: Date;
    dataFinal?: Date;
    valor?: number = 0.00;
    status?: PagamentoStatus;
    idTransacaoMercadoPago?: string;

}